export default ({ post }) => ({
  postImpressionEvents: ({ event, properties }) =>
    post("universe/v1/events", {
      body: { event, properties },
    }),
  trackAnalyticsEvents: ({ event, properties }) =>
    post("universe/v1/analytics", { body: { event, properties } }),
});
